var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.Utilities = OCS.Interfaces.Utilities || {};
OCS.Interfaces.Utilities.calculations = {
    PI: 3.141592653589793238,
    QUARTER_PI: 3.141592653589793238 / 4,
    DEG_PER_RAD: 57.29577951308232088,
    RADIANS_PER_DEGREE: 0.01745329251994329577,
    GOOGLE_RADIUS: 6378137,
    distance: function (coord1, coord2) {
        if (this.is_array_equal(coord1, coord2)) {
            return 0;
        }
        var res = this.array_subtract(coord2, coord1);
        res = this.array_multiply(res, res);
        res = res[0] + res[1];
        return Math.sqrt(res);
    },
    /**
     * Worker function for distance
     *
     * @method find_distance
     */
    find_distance: function (x1, x2, y1, y2) {
        return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    },

    /**
     * Worker function for circle calculation
     *
     * @method find_circle_angle
     */
    find_circle_angle: function (x, y, xc, yc) {
        var distance = this.find_distance(xc, x, yc, y);

        //angle from center to bottom right of bounds:
        var xangle = (180 * Math.acos((x - xc) / distance)) / Math.PI;
        var yangle = (180 * Math.asin((y - yc) / distance)) / Math.PI;

        if (yangle < 0) {
            xangle = 180 + (180 - xangle);
        }

        return xangle;
    },
    /**
     * Convert a data value from one number scale to another number scale. 
     *
     * @method get_frac
     * @param data {float} data point to convert
     * @param data_min {float} old scale min value
     * @param data_max {float} old scale max value
     * @param int_min {float} new scale min value
     * @param int_max {float} new scale max value
     */
    get_frac: function (data, data_min, data_max, int_min, int_max) {
        if (data <= data_min) {
            return int_min;
        }

        if (data >= data_max) {
            return int_max;
        }

        return (int_max - int_min) / (data_max - data_min) * (data - data_min);
    }, //get_frac        
    interpolate: function (value1, value2, fraction) {
        //keeps within range 0->1
        fraction = Math.min(fraction, 1.0);
        fraction = Math.max(fraction, 0.0);
        return  value1 + ((value2 - value1) * fraction);
    },
    /**
     * Convert from Normal Lon/Lat Coordinates to "Google" (900913) coordinates
     *
     * @method lonlat_to_900913
     */
    lonlat_to_900913: function (lambda, phi) {
        var google_radius = this.GOOGLE_RADIUS;
        var proj_x = google_radius * lambda;
        var proj_y = google_radius * Math.log(Math.tan(this.QUARTER_PI + phi / 2));
        return {x: proj_x, y: proj_y};
    },
    lonlat_to_orthographic: function (lambda, phi, center) {
        var orthographic_radius = 6371;
        var x = orthographic_radius * Math.cos(phi) * Math.sin(lambda - center.lambda);
        var y = orthographic_radius * (Math.cos(center.phi) * Math.sin(phi) - Math.sin(center.phi) * Math.cos(phi) * Math.cos(lambda - center.lambda));
        return {x: x, y: y};
    },

    /**
     * Convert from Orthographic Coordinates to "Google" (900913) coordinates
     *
     * @method orthographic_to_900913
     */
    orthographic_to_900913: function (x, y, center) {
        var orthographic_radius = 6371;
        var google_radius = this.GOOGLE_RADIUS;

        var cos_center_lat = Math.cos(center.phi);
        var sin_center_lat = Math.sin(center.phi);

        var rho = Math.sqrt(x * x + y * y);
        var sinC = rho / orthographic_radius;
        var cosC = Math.sqrt(1 - sinC * sinC);
        var lat = Math.asin(cosC * sin_center_lat + (y * sinC * cos_center_lat / rho));
        var lon = center.lambda + Math.atan2(x * sinC, (rho * cos_center_lat * cosC - y * sin_center_lat * sinC));

        var proj_x = google_radius * lon;
        var proj_y = google_radius * Math.log(Math.tan(this.QUARTER_PI + lat / 2));

        return {x: proj_x, y: proj_y};
    },

    /**
     * Convert from polar coordinated to cartesian
     *
     * @method polarToCartesian
     */
    polarToCartesian: function (centerX, centerY, radius, angleInDegrees) {
        var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    },

    /**
     * Builds out the coordinates when drawing an arc (circle). Used for base of wind barb
     *
     * @method describeArc
     */
    describeArc: function (x, y, radius, startAngle, endAngle){
        var start = this.polarToCartesian(x, y, radius, endAngle);
        var end = this.polarToCartesian(x, y, radius, startAngle);

        var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

        var d = [
            "M", start.x, start.y,
            "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
        ].join(" ");

        return d;
    },

    /**
     * Draws wind barb "stem" based on wind speed level.
     *
     * @method windArrow
     */
    windArrow: function(speed) { //draws wind arrow in svg path form. Only vertical and can later be rotated.
        var path;

        var level = this.getWindBarbLevel(speed);

        // The stem and the arrow head
        // path = [
        //     'M', 0, -20, // base of arrow
        //     'L', 0, -3,
        //     -1, -3,
        //     0, 0,
        //     1, -3,
        //     0, -3,
        // ];
        path = [
            'M', 0, -20, // base of arrow
            'L', 0, -1
        ];

        if (level === 2) {
            path.push('M', 0, -18, 'L', 4, -18);
        } else if (level >= 3) {
            path.push(0, -20, 7, -20);
        }

        if (level === 4) {
            path.push('M', 0, -17, 'L', 4, -17);
        } else if (level >= 5) {
            path.push('M', 0, -17, 'L', 7, -17);
        }

        if (level === 6) {
            path.push('M', 0, -14, 'L', 4, -14);
        } else if (level >= 7) {
            path.push('M', 0, -14, 'L', 7, -14);
        }

        if (level === 8) {
            path.push('M', 0, -11, 'L', 4, -11);
        } else if (level >= 9) {
            path.push('M', 0, -11, 'L', 7, -11);
        }

        if (level === 10) {
            path.push('M', 0, -8, 'L', 4, -8);
        } else if (level >= 11) {
            path = [
                'M', 0, -20, // base of arrow
                'L', 0, -1
            ];

            path.push('M', 0, -20, 'L', 6, -15, 0, -12, 'Z');
        }

        var arc1 = this.describeArc(0, 0, 1, 180, 0);
        var arc2 = this.describeArc(0, 0, 1, 0, 180);
        path.push(arc1);
        path.push(arc2);

        return path;
    },

    /**
     * Gets wind barb level for windArrow function
     *
     * @method getWindBarbLevel
     */
    getWindBarbLevel: function (speed) {
        var level = 1;

        if (speed >= 5 && speed < 10) {
            level = 2;
        } else if (speed >= 10 && speed < 15) {
            level = 3;
        } else if (speed >= 15 && speed < 20) {
            level = 4;
        } else if (speed >= 20 && speed < 25) {
            level = 5;
        } else if (speed >= 25 && speed < 30) {
            level = 6;
        } else if (speed >= 30 && speed < 35) {
            level = 7;
        } else if (speed >= 35 && speed < 40) {
            level = 8;
        } else if (speed >= 40 && speed < 45) {
            level = 9;
        } else if (speed >= 45 && speed < 50) {
            level = 10;
        } else if (speed >= 50 && speed < 55) {
            level = 11;
        }
        return level;
    },

    /**
     * List of text directions representing a specific wind degree range
     *
     * @method degtodir
     */
    degtodir: function (inWdirDeg) {
        var direction = '';

        if (inWdirDeg >= 0 && inWdirDeg < 11.25) {
            direction = "N";
        } else if (inWdirDeg >= 11.25  && inWdirDeg < 33.75 ) {
            direction = "NNE";
        } else if (inWdirDeg >= 33.75 && inWdirDeg < 56.75 ) {
            direction = "NE";
        } else if (inWdirDeg >= 56.25 && inWdirDeg < 78.75 ) {
            direction = "ENE";
        } else if (inWdirDeg >= 78.75 && inWdirDeg < 101.25 ) {
            direction = "E";
        } else if (inWdirDeg >= 101.25 && inWdirDeg < 123.75 ) {
            direction = "ESE";
        } else if (inWdirDeg >= 123.75 && inWdirDeg < 146.25 ) {
            direction = "SE";
        } else if (inWdirDeg >= 146.25 && inWdirDeg < 168.75 ) {
            direction = "SSE";
        } else if (inWdirDeg >= 168.75 && inWdirDeg < 191.25 ) {
            direction = "S";
        } else if (inWdirDeg >= 191.25 && inWdirDeg < 213.75 ) {
            direction = "SSW";
        } else if (inWdirDeg >= 213.75 && inWdirDeg < 236.25 ) {
            direction = "SW";
        } else if (inWdirDeg >= 236.25 && inWdirDeg < 258.75 ) {
            direction = "WSW";
        } else if (inWdirDeg >= 258.75 && inWdirDeg < 281.25 ) {
            direction = "W";
        } else if (inWdirDeg >= 281.25 && inWdirDeg < 303.75 ) {
            direction = "WNW";
        } else if (inWdirDeg >= 303.75 && inWdirDeg < 326.25 ) {
            direction = "NW";
        } else if (inWdirDeg >= 326.25  && inWdirDeg < 349.75) {
            direction = "NNW";
        } else if (inWdirDeg >= 349.75) {
            direction = "N";
        } else {
            direction = "N";
        }
        return direction;
    }
};